var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidekick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.773,
    height: 41.69,
    viewBox: "0 0 39.773 41.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.273,
    y1: 0.07,
    x2: 0.754,
    y2: 0.933,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98a0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98d9c8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M38.88,5.79,34.406,3.207A34.055,34.055,0,0,0,19.886,0,34.839,34.839,0,0,0,13.27.632,32.923,32.923,0,0,0,3.1,4.391Q1.972,5.042.893,5.79l-.651.452L.165,7.03a34.524,34.524,0,0,0-.115,5.226l9.311,5.376,16.166,9.333a26.147,26.147,0,0,1-5.64,5.157L1.921,21.75q.273.783.582,1.551A34.541,34.541,0,0,0,19.122,41.309l.765.381.765-.381a34.474,34.474,0,0,0,12.17-10.133A34.663,34.663,0,0,0,37,23.958L29.7,19.748,12.017,9.537a26.2,26.2,0,0,1,7.869-1.2,25.774,25.774,0,0,1,10.671,2.275q.439.2.87.419l0,.082L39.363,15.7a34.479,34.479,0,0,0,.244-8.668l-.077-.788Z",
    transform: "translate(0)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidekick);
export default __webpack_public_path__ + "static/media/sidekick.d81c2d727b344b34534ad7cba0fa21c6.svg";
export { ForwardRef as ReactComponent };